import type { CSSProperties } from 'react'
import { Skeleton } from '@/components/ui/skeleton'
import { messages } from '@/lib/messages'

interface LoadingProps {
  /** Görsel iskelet satır sayısı; tablo/liste yüzeylerinde satır sayısını taklit eder. */
  rows?: number
  label?: string
}

/** Veri yüzeylerinin dört zorunlu durumundan biri (AGENTS.md §10). */
export function Loading({ rows = 5, label = messages.states.loading }: LoadingProps) {
  return (
    <div className="flex flex-col gap-2 p-4" role="status" aria-live="polite">
      <span className="sr-only">{label}</span>
      {Array.from({ length: rows }, (_, index) => (
        <Skeleton
          key={index}
          className="h-8 w-full"
          style={{ '--index': index } as CSSProperties}
        />
      ))}
    </div>
  )
}
